import { FC } from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonReviewCard: FC = () => (
  <div className="card my-3 ">
    <div className="card-content">
      <span className="p-1">
        <Skeleton />
      </span>
      <span className="p-1 is-size-7">
        <Skeleton />
      </span>
      <br />
      <span className="p-1 is-size-7">
        <Skeleton />
      </span>
      <span className="p-1 is-size-7">
        <Skeleton />
      </span>
    </div>
  </div>
);

export default SkeletonReviewCard;
